"use strict";

import "core-js/modules/es.symbol.description.js";
import { Box, Column, Columns, Stack, Text, useResponsiveValue } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { HeadingSection } from '~/src/components/HeadingSection/HeadingSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ManageAllFleetVehiclesCarousel = ({
  isDesktop,
  content
}) => {
  return /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsxs(Columns, {
      width: "full",
      noWrap: useResponsiveValue([false,, true]),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: ['column',, 'row'],
      children: [/*#__PURE__*/_jsx(Column, {
        paddingRight: "6",
        alignSelf: "centre",
        children: /*#__PURE__*/_jsxs(Stack, {
          space: "6",
          children: [/*#__PURE__*/_jsx(HeadingSection, {
            title: content.title,
            alignItems: ['center', 'flexStart', 'flexStart'],
            align: isDesktop ? 'left' : 'center',
            size: isDesktop ? '8' : '7',
            colour: "white"
          }), /*#__PURE__*/_jsx(Box, {
            paddingBottom: "7",
            children: /*#__PURE__*/_jsx(Text, {
              as: "p",
              align: isDesktop ? 'left' : 'center',
              colour: "white",
              size: "4",
              children: content.description
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Column, {
        children: /*#__PURE__*/_jsx(Picture, {
          backgroundColor: "transparent",
          src: content.uspImgPath,
          width: "100%",
          height: "auto",
          aspectRatio: content.aspectRatio,
          altText: content.uspAltImg,
          sizes: "(max-width: 1023px) 100vw, (min-width: 1024px) 750px"
        })
      })]
    })
  });
};